import React from 'react'
import { StyledButton } from 'component-library/buttons/Button/Button.styled'

export interface Props {
    type?: React.ButtonHTMLAttributes<any>['type']
    className?: string
    disabled?: boolean
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

export const Button: React.FC<Props> = ({ type, className, disabled, onClick, children }) => (
    <StyledButton disabled={disabled} type={type} className={className} onClick={onClick}>
        {children}
    </StyledButton>
)
